// libs
// import $ from "jquery";

// local
import PageBase from "./PageBase";


export default class ConceptApp extends PageBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    const dispatcher = this.initTopImage();
    dispatcher.bind("init", () => {
      this.initFadeAnimation();
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/ConceptApp.js